import useStyles from './styles';
import { copyToClipboard } from '../../../../utilities/helpers';

// MUI Imports
import { Box } from '@mui/system';
import { Typography, IconButton } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const NetworkCode = ({ networkCode, successMessage }) => {
	const classes = useStyles();
	return (
		<Box className={classes.output}>
			<IconButton
				style={{ position: 'absolute', top: '1rem', right: '1rem' }}
				onClick={() => copyToClipboard(networkCode, successMessage)}
			>
				<ContentCopyIcon />
			</IconButton>
			<Typography
				sx={{
					whiteSpace: 'pre-wrap'
				}}
			>
				{networkCode}
			</Typography>
		</Box>
	);
};

export default NetworkCode;
